// extracted by mini-css-extract-plugin
export default {"container":"BookDetails_container__pdCjV","iconContainer":"BookDetails_iconContainer__lVL+B","separator":"BookDetails_separator__0f0Pa"};